import React from 'react';
import { useContext } from 'react';
import { StoreContext } from './store';
import { useLocation, matchPath } from 'react-router-dom';
import Nav from './components/LandingNav';
import LandingHeader from './components/LandingHeader';
import HeaderMobile from './components/LandingHeaderMobile';
import Footer from './components/Footer';
import { FloatingChatbot } from '@walkspan/chatbot';

import LimitModal from './components/ReachedLimit/limit-modal';

const MainLayout = ({ children }) => {
  const { state } = useContext(StoreContext);
  const { isMobile, showLimitModal } = state;
  const location = useLocation();
  const pathsWithHeaderFooter = [
    '/',
    '/home-test',
    '/platform',
    '/contact-us',
    '/announcements',
    '/about-us',
    '/address/*',
    '/services/*',
    '/pricing',
    '/book-demo',
    '/why-us',
    '/faqs',
    '/newsletter',
  ];

  const pathsWithLandingHeader = [
    // '/about-us',
    '/services',
    '/announcements',
    '/pricing',
    '/contact-us',
    '/book-demo',
  ];

  const showLandingHeader = pathsWithLandingHeader.some(path =>
    location.pathname.includes(path)
  );

  const showHeaderFooter = pathsWithHeaderFooter
    .concat('/newsletter/:id')
    .some(path =>
      matchPath({ path, exact: false }, location.pathname)
    );

  const showChatbot = ['/'].includes(location.pathname);

  return (
    <div className={`main-layout ${showHeaderFooter && !isMobile ? 'pt-[80px]' : ''}`}>
      {showHeaderFooter && <Nav />}
      {showHeaderFooter && <HeaderMobile />}
      {/* {showLandingHeader && <LandingHeader />} */}
      <LimitModal isOpen={showLimitModal} />
      {children}
      {showChatbot && <FloatingChatbot
        title="Walkspan AI"
        apiUrl="https://api.senseofwalk.com/api/chatbot/parse"
        headers={{
          Authorization: "Bearer token"
        }}
        position='bottom-right'
      />}
      {showHeaderFooter && <Footer />}
    </div>
  );
};

export default MainLayout;
